import { render, staticRenderFns } from "./BillStorageDetail.vue?vue&type=template&id=492fbe2a&scoped=true"
import script from "./BillStorageDetail.vue?vue&type=script&lang=js"
export * from "./BillStorageDetail.vue?vue&type=script&lang=js"
import style0 from "./BillStorageDetail.vue?vue&type=style&index=0&id=492fbe2a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492fbe2a",
  null
  
)

export default component.exports